"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Key_exports = {};
__export(Key_exports, {
  default: () => Key_default
});
module.exports = __toCommonJS(Key_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.6133 3.14062C16.5221 3.04948 16.4049 3.00391 16.2617 3.00391C16.1185 3.00391 16.0013 3.04948 15.9102 3.14062L9.50391 9.54688C8.67057 9.01302 7.7526 8.79818 6.75 8.90234C5.7474 8.99349 4.88151 9.39714 4.15234 10.1133C3.73568 10.5299 3.42318 11.0052 3.21484 11.5391C3.00651 12.0599 2.90234 12.6003 2.90234 13.1602C2.90234 13.707 3.00651 14.2409 3.21484 14.7617C3.42318 15.2826 3.73568 15.7578 4.15234 16.1875C4.56901 16.6042 5.04427 16.9167 5.57812 17.125C6.09896 17.3333 6.63281 17.4375 7.17969 17.4375C7.72656 17.4375 8.26693 17.3333 8.80078 17.125C9.32161 16.9167 9.79036 16.6042 10.207 16.1875C10.6237 15.7708 10.9362 15.3021 11.1445 14.7812C11.3529 14.2604 11.457 13.7331 11.457 13.1992C11.4701 12.6523 11.3789 12.1185 11.1836 11.5977C10.9883 11.0768 10.6888 10.6081 10.2852 10.1914L12.4531 8.02344L14.5039 10.0742C14.6471 10.2174 14.8099 10.2891 14.9922 10.2891C15.1875 10.2891 15.3568 10.2174 15.5 10.0742L17.8828 7.71094C18.013 7.56771 18.0781 7.39844 18.0781 7.20312C18.0781 7.00781 18.013 6.84505 17.8828 6.71484L15.8125 4.64453L16.6133 3.84375C16.7174 3.7526 16.7695 3.64193 16.7695 3.51172C16.7695 3.36849 16.7174 3.24479 16.6133 3.14062ZM15.1289 5.36719L16.9648 7.20312L14.9922 9.15625L13.1562 7.32031L15.1289 5.36719ZM4.85547 15.4648C4.21745 14.8268 3.89844 14.0586 3.89844 13.1602C3.89844 12.2487 4.21745 11.474 4.85547 10.8359C5.50651 10.1849 6.28125 9.85938 7.17969 9.85938C8.09115 9.85938 8.86589 10.1849 9.50391 10.8359C10.1419 11.474 10.4609 12.2487 10.4609 13.1602C10.4609 14.0586 10.1419 14.8268 9.50391 15.4648C8.86589 16.1159 8.09115 16.4414 7.17969 16.4414C6.28125 16.4414 5.50651 16.1159 4.85547 15.4648Z",
      fill: "currentColor"
    }
  )
);
const SvgKey = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Key_default = SvgKey;
